export type SerializedStudent = { name: string, selections: Array<string>, id: number,
    has_been_selected: boolean, sel_by_other: number, sel_match: number };

export class Student {
    private pName: string;
    private pId: number;
    private pMaxSelections: number;
    private pSelections: string[];
    private pHasBeenSelected: boolean;
    private pSelectedByOther: number;
    private pSelectedByOtherMatch: number;

    constructor(name: string, id: number) {
        this.pName = name;
        this.pId = id;

        this.pSelections = [];
        this.pMaxSelections = 3;
        this.pHasBeenSelected = false;
        this.pSelectedByOther = 0;
        this.pSelectedByOtherMatch = 0;
    }

    add_selection(name: string): void {
        if (!this.pSelections.includes(name)) {
            if (this.pSelections.length < this.pMaxSelections) {
                this.pSelections.push(name);
            }
        }
    }

    set_selected_if_matching(id: number, selectedByName: string): void {
        if (this.id === id) {
            this.pHasBeenSelected = true;

            if (this.pSelections.includes(selectedByName)) {
                this.pSelectedByOtherMatch++;
            } else {
                this.pSelectedByOther++;
            }
        }
    }

    get diagram_data(): object {
        return {name: this.name, single: this.pSelectedByOther, match: this.pSelectedByOtherMatch};
    }

    get id(): number {
        return this.pId;
    }

    get is_selected(): boolean {
        return this.pHasBeenSelected;
    }

    get name(): string {
        return this.pName;
    }

    get number_of_selections(): number {
        return this.pSelectedByOther + this.pSelectedByOtherMatch;
    }

    get selections(): string[] {
        return this.pSelections;
    }

    get serialize(): SerializedStudent {
        return { name: this.pName, selections: this.pSelections, id: this.pId, has_been_selected: this.pHasBeenSelected,
            sel_by_other: this.pSelectedByOther, sel_match: this.pSelectedByOtherMatch };
    }

    deserialize(json: SerializedStudent): void {
        this.pName = json.name;
        this.pSelections = json.selections;
        this.pId = json.id;
        this.pHasBeenSelected = json.has_been_selected;
        this.pSelectedByOther = json.sel_by_other;
        this.pSelectedByOtherMatch = json.sel_match;
    }
}